<div class="container my-4">
    <div class="row">
        <div class="col-12 text-right mb-2">
            <label style="color:crimson; font-size:15px;font-weight:bold;">
                Last Updated On :</label>
            <label class="ml-2" style="font-weight:bold;color:crimson;">{{updatedTime?.date |
                date:'dd/MM/yyyy'}}</label>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <span class="title_header_bar">Today Statistics</span>
        </div>
    </div>


    <div class="row my-2">
        <div class="col-xl-3">
            <div class="card-boxtotalbalance">
                <span class="totalbalance-icon">
                    <div class="right  ion fa fa-users iconsize"></div>
                </span>
                <div class="inner">
                    <h4>{{!totalVisitor?'0':totalVisitor}} </h4>
                    <p> Total Visitor </p>
                </div>
            </div>
        </div>
        <div class="col-xl-3">
            <div class="card-boxtotalbalance">
                <span class="totalbalance-icon">
                    <div class="right  ion fa fa-user-plus iconsize"></div>
                </span>
                <div class="inner">
                    <h4>{{!newVisitor?'0':newVisitor}} </h4>
                    <p>New Visitor </p>
                </div>

            </div>
        </div>
        <div class="col-xl-3">
            <div class="card-boxtotalbalance">
                <span class="totalbalance-icon">
                    <div class="right ion fa fa-globe iconsize"></div>
                </span>
                <div class="inner">
                    <h4>{{!totalCoverage?'0':totalCoverage}}</h4>
                    <p>Total Coverage</p>
                </div>
            </div>
        </div>

        <div class="col-xl-3">
            <div class="card-boxtotalbalance">
                <span class="totalbalance-icon">
                    <div class="right ion fa fa-check-circle iconsize"></div>
                </span>
                <div class="inner">
                    <h4>{{!availableCoverage?'0':availableCoverage}}</h4>
                    <p>Available Coverage</p>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-12">
            <div class="dropdown text-right">
                <div class="btn btn-primary dropdown-toggle" (click)="toggleDropdown()">
                    <i class="icon-calendar"></i>&nbsp;&nbsp;
                    <span class="thin uppercase hidden-xs">{{Month}}</span>
                </div>
                <ul class="dropdown-menu dateranges pull-right" [class.show]="dropdownOpen" *ngIf="dropdownOpen">
                    <li (click)="selectMonth(0); $event.preventDefault()">
                        <a href="">{{CurrrentMonth}}</a>
                    </li>
                    <li (click)="selectMonth(1); $event.preventDefault()">
                        <a href="">{{LastMonth}}</a>
                    </li>
                    <li (click)="selectMonth(2); $event.preventDefault()">
                        <a href="">{{LastBeforeMonth}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>


    <div class="row mt-4">
        <div class="col-12">
            <span class="title_header_bar">Login Trend Analysis
                <mat-slide-toggle (click)="loginTrendActivity()" color="primary" style="margin-left: 10px;">
                </mat-slide-toggle>
            </span>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card-boxtotalbalance py-4 mt-0" style="border-radius: 0 !important;">
                <div id="chart">
                    <div id="chart">
                        <apx-chart [series]="chartSeries" [chart]="chartOptions?.chart" [xaxis]="chartOptions?.xaxis"
                            [title]="chartOptions?.title" [tooltip]="chartOptions?.tooltip"
                            [stroke]="chartOptions?.stroke" [fill]="chartOptions?.fill"
                            [dataLabels]="chartOptions?.dataLabels" [markers]="chartOptions?.markers"
                            [yaxis]="chartOptions?.yaxis" [legend]="chartOptions?.legend"></apx-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="row">
        <div class="col-xl-12">
            <div class="dropdown text-right">
                <div class="btn btn-primary dropdown-toggle" (click)="toggleDropdown()">
                    <i class="icon-calendar"></i>&nbsp;&nbsp;
                    <span class="thin uppercase hidden-xs">{{CoverageMonth}}</span>
                </div>
                <ul class="dropdown-menu dateranges pull-right" [class.show]="dropdownOpen" *ngIf="dropdownOpen">
                    <li (click)="selectMonthCoverage(0); $event.preventDefault()">
                        <a href="">{{CurrrentCoverageMonth}}</a>
                    </li>
                    <li (click)="selectMonthCoverage(1); $event.preventDefault()">
                        <a href="">{{LastCoverageMonth}}</a>
                    </li>
                    <li (click)="selectMonthCoverage(2); $event.preventDefault()">
                        <a href="">{{LastBeforeCoverageMonth}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>



    <div class="row mt-4">
        <div class="col-12">
            <span class="title_header_bar">Coverage Trend Analysis
            </span>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card-boxtotalbalance py-4 mt-0" style="border-radius: 0 !important;">
                <div id="chart">
                    <div id="chart">
                        <apx-chart [series]="coverageChartSeries" [chart]="coverageChartOptions?.chart"
                            [xaxis]="coverageChartOptions?.xaxis" [title]="coverageChartOptions?.title"
                            [tooltip]="coverageChartOptions?.tooltip" [stroke]="coverageChartOptions?.stroke"
                            [fill]="coverageChartOptions?.fill" [dataLabels]="coverageChartOptions?.dataLabels"
                            [markers]="coverageChartOptions?.markers" [yaxis]="coverageChartOptions?.yaxis"
                            [legend]="coverageChartOptions?.legend"></apx-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div #scrolltoBottom></div>

    <!-- <div class="row body-content">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
            <div class="panel" style="margin-bottom: -23px">

            </div>
            <div class="dataport1 portlet light bordered">
                <div class="portlet-title">
                    <h4 class="text-center">Coverage Activity for {{ CoverageMonth}}</h4>
                </div>
                <div class="portlet-body">
                    <div class="chart-column">
                        <canvas class="chart chart-line" chart-colors="coverageactivitycolors"
                            chart-data="coverageactivitydata" chart-series="coverageactivityseries"
                            chart-labels="coverageactivitylabels" chart-options="coverageactivityoptions">
                        </canvas>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>